import { CreateRepositoryInfoDto, FindOneRepositoryResponse, FindRepositoriesResponse } from '@/@types/theoryGit/repositoryInfo';
import { RepositoryFactory } from '@/repository/factory/repositoryFactory';
import {
  createModule,
  action,
  mutation,
} from 'vuex-class-component';

const VuexModule = createModule({
  namespaced: 'theoryGitRepositoryInfoStore',
  strict: false,
});

export class RepositoryInfoStore extends VuexModule {
  private readonly repositoryInfoRepository = RepositoryFactory.theoryGit.repositoryInfoRepository();
  /**state */
  private repositories: FindRepositoriesResponse | null = null;
  private repositoryInfo: FindOneRepositoryResponse | null = null;

  @mutation
  private setRepositories(payload: FindRepositoriesResponse) {
    this.repositories = payload;
  }

  @mutation
  private setRepositoryOne(payload: FindOneRepositoryResponse) {
    this.repositoryInfo = payload;
  }

  @mutation
  private init(payload: null) {
    this.repositories = payload;
    this.repositoryInfo = payload;
  }

  @action
  async fetchRepositories(projectId: number) {
    const results = await this.repositoryInfoRepository.findRepositories(projectId);
    this.setRepositories(results);
  }

  /**リポジトリ詳細取得 */
  @action
  async fetchOneRepository(params: {
    repositoryInfoId: number,
    projectId: number,
  }) {
    const results = await this.repositoryInfoRepository.findOneRepository(
      params.repositoryInfoId,
      params.projectId,
    );
    this.setRepositoryOne(results);
  }

  /**リポジトリ作成 */
  @action
  async createRepository(params: CreateRepositoryInfoDto) {
    const results = await this.repositoryInfoRepository.createRepository(params);
    return results;
  }

  /**リポジトリ削除 */
  async deleteRepository(params: { repositoryInfoId: number, projectId: number }) {
    await this.repositoryInfoRepository.deleteRepository(params.repositoryInfoId, params.projectId);
  }

  @action
  async initState() {
    this.init(null);
  }

  get getRepositories() {
    return this.repositories;
  }

  get getRepositoryInfo() {
    return this.repositoryInfo;
  }
}
